export default {
    SUPER_ADMIN: 1,
    ADMIN: 2,
    STORE_MANAGER: 3,
    CASHIER: 4,
    ACCOUNTANT: 5
}


// WEBPACK FOOTER //
// ./src/common/constants/roles.js